import { ArrowLeftIcon, ArrowRightIcon, EyeIcon } from '@heroicons/react/24/outline'
import React, { useRef } from 'react'
import { Link } from 'react-router-dom'
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useCartActions } from '../hooks/use-cart-actions'
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import { usePricingModel } from '../hooks/use-pricing-model'
import { thousandSeparator } from './utils'
import { useAnalytics } from '../hooks/use-analytics'

interface SwiperComponentProps {
  products: any[];
  handleSelctedProduct?: (selectedProduct: any) => void;
  handleModal?: () => void;
}

export const SwiperComponent = ({products, handleModal, handleSelctedProduct}: SwiperComponentProps) => {

  const { handleAddToCart } = useCartActions();
  const { trackProductView } = useAnalytics();
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const { renderProductPricingModelJSON } = usePricingModel();

  const handleProductView = (product: any) => {
    trackProductView(product.id.toString(), product.category?.name, product.price);
    handleModal && handleModal();
    handleSelctedProduct && handleSelctedProduct(product);
  };

  return (
    <>
      {
        products.length === 0 && (
          <div className="text-center">
            <h5 className='text-uppercase'>No products available</h5>
          </div>
        )
      }
      {
        products.length > 0 && (
          <>
            <Swiper
              modules={[Navigation]}
              spaceBetween={20}
              slidesPerView={4}
              navigation={{
                nextEl: '.icon-arrow-left',
                prevEl: '.icon-arrow-right'
              }}
              loop={true}
              onInit={(swiper) => {
                // @ts-ignore
                swiper.params.navigation.prevEl = prevRef.current;
                // @ts-ignore
                swiper.params.navigation.nextEl = nextRef.current;
                swiper.navigation.init();
                swiper.navigation.update();
              }}
              breakpoints={{
                0: { slidesPerView: 2 },
                999: { slidesPerView: 3 },
                1366: { slidesPerView: 4 }
              }}
              className='product-swiper open-up'
              data-aos="zoom-out"
            >
              {products.map(product => {
                const { price, priceString, strikeThroughPriceString, discountOff } = renderProductPricingModelJSON(product);
                const newProduct = { ...product, productImages: [], inventories: [], price, priceString, strikeThroughPriceString: strikeThroughPriceString, discountOff }
                return (
                  <SwiperSlide key={newProduct.id}>
                    <div className="product-item image-zoom-effect link-effect">
                      <div className="image-holder position-relative">
                        <Link 
                          to={`#`} 
                          onClick={() => handleProductView(newProduct)}
                        >
                          <img src={newProduct.image} alt={newProduct.name} width='416px' height='448px' className="product-image img-fluid" />
                        </Link>
                        <Link 
                          to={`#`} 
                          onClick={() => handleProductView(newProduct)}
                          className="btn-icon btn-wishlist"
                        >
                          <EyeIcon width={23}  />
                        </Link>
                        <div className="product-content">
                          <h5 className="text-uppercase fs-5 mt-3">
                            <Link to={`#`}>{newProduct.name}</Link>
                          </h5>
                          {product.pouchesInCarton && product.productWeight && (
                            <section style={{
                              fontSize: '.8em',
                              color: '#000',
                              display: 'flex',
                              marginBottom: '.5rem',
                              flexFlow: 'row nowrap',
                              justifyContent: 'space-between'
                            }}>
                              <span className='m-0'>{ thousandSeparator(String(product.pouchesInCarton)) } {product.unit === 'ml' ? 'bottles' : 'pouches'} in carton</span>
                              <span 
                                className='m-0'
                                style={{
                                  padding: '4px 10px',
                                  borderRadius: '200px',
                                  backgroundColor: '#3a974c1a',
                                  fontSize: '.75em',
                                  color: '#3A974C',
                                  fontWeight: 700,
                                }}
                              >{ product.productWeight }{product.unit}</span>
                            </section>
                          )}
                          <Link to="#" onClick={() => handleAddToCart(newProduct)} className="text-decoration-none" data-after="Add to cart">
                            <span>{ priceString }</span>
                            {strikeThroughPriceString && (<span className="text-danger" style={{
                              textDecoration: 'line-through',
                              marginLeft: '5px',
                              fontSize: '.8rem'
                            }}>{  strikeThroughPriceString }</span>)}
                          </Link>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                )
              })}
            </Swiper>
            <button className="icon-arrow icon-arrow-right" ref={prevRef}><ArrowRightIcon /></button>
            <button className="icon-arrow icon-arrow-left" ref={nextRef}><ArrowLeftIcon /></button>
          </>
        )
      }
    </>
  )
}